import React from 'react';
import { GoogleLogin, googleLogout } from '@react-oauth/google';

class LoginComponent extends React.Component {
  constructor(props) {
    super(props);
    this.setIsLoggedIn = this.props.setIsLoggedIn;
    this.state = {
      email: '',
      password: '',
    };
  }

  handleSubmit = async (event) => {
    event.preventDefault();

    const { email, password } = this.state;

    const requestBody = {
      email,
      password,
    };

    try {
      const loginUrl = `${process.env.REACT_APP_API_BASE_URL}/login`;

      const response = await fetch(loginUrl, {
        method: 'POST',
        credentials: 'include',
        body: JSON.stringify(requestBody),
      });

      const data = await response.json();
      console.log(data);
      if (response.status == 200) {
        this.setIsLoggedIn(true);
      }
    } catch (error) {
      console.error(error);
    }
  };

  handleEmailChange = (event) => {
    this.setState({ email: event.target.value });
  };

  handlePasswordChange = (event) => {
    this.setState({ password: event.target.value });
  };

  render() {
    const { email, password } = this.state;
    var signinLink = ''
    var signupLink = ''
    if (process.env.REACT_APP_API_BASE_URL == 'http://localhost:3000') {
      signinLink = `https://${process.env.REACT_APP_COGNITO_HOSTED_AUTH_DOMAIN}/login?client_id=${process.env.REACT_APP_COGNITO_CLIENT_ID}&response_type=code&scope=aws.cognito.signin.user.admin+email+openid+phone+profile&redirect_uri=http%3A%2F%2Flocalhost%3A3000%2FauthCallbackLocal`
    } else {
      signinLink = `https://${process.env.REACT_APP_COGNITO_HOSTED_AUTH_DOMAIN}/login?client_id=${process.env.REACT_APP_COGNITO_CLIENT_ID}&response_type=code&scope=aws.cognito.signin.user.admin+email+openid+phone+profile&redirect_uri=https%3A%2F%2Fkoy.parent-ai.com%2FauthCallback%2F`
    }
    if (process.env.REACT_APP_API_BASE_URL == 'http://localhost:3000') {
      signupLink = `https://${process.env.REACT_APP_COGNITO_HOSTED_AUTH_DOMAIN}/signup?client_id=${process.env.REACT_APP_COGNITO_CLIENT_ID}&response_type=code&scope=aws.cognito.signin.user.admin+email+openid+phone+profile&redirect_uri=http%3A%2F%2Flocalhost%3A3000%2FauthCallbackLocal`
    } else {
      signupLink = `https://${process.env.REACT_APP_COGNITO_HOSTED_AUTH_DOMAIN}/signup?client_id=${process.env.REACT_APP_COGNITO_CLIENT_ID}&response_type=code&scope=aws.cognito.signin.user.admin+email+openid+phone+profile&redirect_uri=https%3A%2F%2Fkoy.parent-ai.com%2FauthCallback%2F`
    }


    // Check if both fields are not empty
    const isButtonDisabled = !(email && password);
    return (
      <div className="App-left">
        <h1>Welcome to Koy by Parent-AI, your collaborative tool for today's modern village!</h1>
        <p>We've all heard the saying, "It takes a village to raise a child". Here at Parent-AI, we not only believe in that sentiment but we've also brought it to life in the digital age.</p>
        <p>Juggling children's activities across different households can be a daunting task. From managing school events and hobby classes to coordinating play dates and shared rides for sports practices, parenting can often feel like an overwhelming marathon. But what if we could transform those responsibilities into opportunities for community building and shared experiences?</p>
        <p>That's where Koy steps in. We've crafted an intuitive, comprehensive platform designed to streamline the coordination and communication between busy parents and guardians. With Koy, you can effortlessly track your kids' activities, collaborate with other parents, and share responsibilities like driving kids to baseball practice or supervising a study group. It's about creating a supportive network that makes managing and coordinating activities a breeze.</p>
        <p>Our mission is to simplify your life, strengthen your community, and allow you to focus on what truly matters - cherishing the precious moments of parenthood. Whether you're a single parent, a guardian, or part of a bustling household, Koy by Parent-AI is here to bring the power of the village right to your fingertips.</p>
        <p>Join Koy today and experience a more connected, collaborative, and stress-free way to manage your children's activities. Because together, we make family feel like a team! Welcome to your modern village.</p>
        <p>You can <a href='https://testflight.apple.com/join/WNvs1vST'>join the beta</a> of our iOS app today!</p>
        <p>You can also <a href={signinLink}>log in</a> or <a href={signupLink}>sign up now</a> on Web (with limited functionality) to become a part of this community!</p>
      </div>
    );
  }
}

export default LoginComponent;

/*
        <form onSubmit={this.handleSubmit}>
          <label>
            Email:
            <input type="email" value={email} onChange={this.handleEmailChange} />
          </label>
          <label>
            Password:
            <input type="password" value={password} onChange={this.handlePasswordChange} />
          </label>
          <button type="submit" disabled={isButtonDisabled}>Login</button>
        </form>
      */